import { FC, ReactNode } from 'react';
import { Footer, Partners } from 'components';

import logo from 'assets/images/logo-login.svg';
import loginText from 'assets/images/login-text.svg';
import sportsLogo from 'assets/images/partners/sports.svg';
import fifaLogo from 'assets/images/partners/fifa.svg';

import styles from './Welcome.module.scss';

interface IWelcome {
  children: ReactNode;
}

export const Welcome: FC<IWelcome> = ({ children }) => {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <Partners isLight className={styles.partnersSlider} />
        <div className={styles.top}>
          <div className={styles.left}>
            <img className={styles.loginText} src={loginText} alt="loginText" />
            <div className={styles.partners}>
              <img className={styles.partner} src={sportsLogo} alt="sportsLogo" />
              <img className={styles.partner} src={fifaLogo} alt="fifaLogo" />
            </div>
          </div>
          <div className={styles.right}>
            <img className={styles.logo} src={logo} alt="logo" />
          </div>
        </div>
        <div className={styles.bottom}>{children}</div>
      </div>
      <Footer />
    </div>
  );
};
